import {
  Badge as CoreBadge,
  badgeVariants,
  type BadgeProps as CoreBadgeProps,
} from "@vortexnyc/vortex-core/ui";

type PortalBadgeVariant =
  | NonNullable<CoreBadgeProps["variant"]>
  | "default"
  | "secondary"
  | "information";

export type BadgeProps = Omit<CoreBadgeProps, "variant"> & {
  variant?: PortalBadgeVariant;
};

function mapBadgeVariant(
  variant: PortalBadgeVariant | undefined
): CoreBadgeProps["variant"] {
  if (variant === undefined) {
    return undefined;
  }
  if (variant === "secondary") {
    return "neutral";
  }
  if (variant === "information" || variant === "default") {
    return "primary";
  }
  return variant;
}

function Badge({ variant, ...props }: BadgeProps) {
  return <CoreBadge variant={mapBadgeVariant(variant)} {...props} />;
}

export { Badge, badgeVariants };
